import { css } from '@emotion/css';

import { Colors, SMALL_DEVICE_MQ, Spacing } from '../../styles/constants';

export const carouselClassName = css({
  margin: `0 -${Spacing['2XS']}px`,
  position: 'relative',
});

export const innerClassName = css({
  display: 'flex',
  flexDirection: 'row',
  height: '100%',
  overflowX: 'auto',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
});

export const rowClassName = css({
  display: 'flex',
  flexDirection: 'row',
  height: '100%',
});

export const itemClassName = css({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'center',
  padding: `0 ${Spacing['2XS']}px`,
});

export const actionClassName = css({
  alignItems: 'center',
  background: 'rgba(255, 255, 255, 0.85)',
  border: '2px solid #F0F0F0',
  borderRadius: '50%',
  cursor: 'pointer',
  display: 'none',
  justifyContent: 'center',
  height: 38,
  width: 38,
  position: 'absolute',
  top: 'calc(50% - 19px)',
  zIndex: 200,
  [SMALL_DEVICE_MQ]: {
    display: 'flex',
  },
});

export const leftActionClassName = css({
  left: `-${Spacing.XS}px`,
});

export const rightActionClassName = css({
  right: `-${Spacing.XS}px`,
});

export const iconClassName = css({
  display: 'block',
  lineHeight: 0,

  svg: {
    fill: Colors.Black,
    height: 14,
    width: 14,
  },
});

export const disabledActionClassName = css({
  cursor: 'default',

  'i > svg': {
    fill: '#CCC',
  },
});
